import { Button, Modal } from "react-bootstrap";
import googleConnectGuide from "../../assets/images/google-mailbox-connect-guide.svg";

type GoogleMailboxConnectModalProps = {
  show: boolean;
  onHide: () => void;
  onContinue: () => void;
};

export default function GoogleMailboxConnectModal({
  show,
  onHide,
  onContinue,
}: GoogleMailboxConnectModalProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-dialog-centered google-mailbox-connect-modal"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Connect your Google mailbox</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="google-mailbox-connect-modal__layout">
          <div className="google-mailbox-connect-modal__image-wrap">
            <img
              src={googleConnectGuide}
              alt="Google permission screen showing Allow for send email on your behalf"
              className="google-mailbox-connect-modal__image"
            />
          </div>

          <div className="google-mailbox-connect-modal__steps">
            <p className="google-mailbox-connect-modal__intro">
              You&apos;ll be redirected to Google to connect your mailbox.
            </p>
            <ol>
              <li>Sign in with the Google account you want to send gifts from.</li>
              <li>
                When Google asks for permission, click{" "}
                <strong>Allow</strong> for{" "}
                <strong>Send email on your behalf</strong>.
              </li>
              <li>Google will send you back here once connected.</li>
            </ol>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onContinue}>
          Continue to Google
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
